/**
 * Help - Gebruikershandleiding
 * EXACT zoals Morris help.html
 */

import BoekhoudingLayout from '../../components/boekhouding/BoekhoudingLayout';
import styles from '../../styles/Boekhouding.module.css';

const Help = () => {
  return (
    <BoekhoudingLayout title="Gebruikershandleiding">
      <div className={styles.helpContent}>

        {/* Quick navigation */}
        <div className={styles.navQuick}>
          <strong>Snel naar:</strong>
          <a href="#dashboard">Dashboard</a>
          <a href="#boekingen">Boekingen</a>
          <a href="#koppelen">Koppelen</a>
          <a href="#btw">BTW</a>
          <a href="#dc">D&C</a>
          <a href="#relaties">Relaties</a>
          <a href="#jaarrekening">Jaarrekening</a>
          <a href="#instellingen">Instellingen</a>
          <a href="#tips">Tips</a>
          <a href="#mobiel">Mobiel</a>
        </div>

        {/* Dashboard */}
        <div className={styles.helpSection}>
          <h2 id="dashboard">Het Dashboard</h2>
          <p>Na het inloggen zie je het dashboard met:</p>
          <ul>
            <li><strong>Omzet dit jaar</strong> - Totaal van alle verkopen</li>
            <li><strong>Kosten dit jaar</strong> - Totaal van alle inkopen</li>
            <li><strong>BTW te betalen</strong> - Verschil tussen ontvangen en betaalde BTW</li>
            <li><strong>Snelkoppelingen</strong> - Knoppen om snel een nieuwe boeking toe te voegen</li>
          </ul>
        </div>

        {/* Navigatie */}
        <div className={styles.helpSection}>
          <h2 id="navigatie">Navigatie (linkermenu)</h2>
          <table>
            <tbody>
              <tr><th>Menu</th><th>Wat het doet</th></tr>
              <tr><td><strong>Dashboard</strong></td><td>Overzicht van je cijfers</td></tr>
              <tr><td><strong>Boekingen</strong></td><td>Alle transacties bekijken en toevoegen</td></tr>
              <tr><td><strong>Leningen</strong></td><td>Overzicht van leningen</td></tr>
              <tr><td><strong>BTW Overzicht</strong></td><td>BTW aangifte per kwartaal</td></tr>
              <tr><td><strong>D&C</strong></td><td>Debiteuren & Crediteuren (wie moet betalen/krijgen)</td></tr>
              <tr><td><strong>Kapitaal</strong></td><td>Eigen vermogen overzicht</td></tr>
              <tr><td><strong>Afschrijvingen</strong></td><td>Bedrijfsmiddelen en afschrijvingen</td></tr>
              <tr><td><strong>Exploitatie</strong></td><td>Winst- en verliesrekening</td></tr>
              <tr><td><strong>Balans</strong></td><td>Balans van je bedrijf</td></tr>
              <tr><td><strong>Relaties</strong></td><td>Klanten en leveranciers beheren</td></tr>
              <tr><td><strong>Jaarrekening</strong></td><td>Complete jaarrekening (ook als PDF)</td></tr>
              <tr><td><strong>Instellingen</strong></td><td>Instellingen en grootboekrekeningen beheren</td></tr>
            </tbody>
          </table>
        </div>

        {/* Boekingen */}
        <div className={styles.helpSection}>
          <h2 id="boekingen">Boekingen</h2>

          <h3>Soorten boekingen</h3>
          <p>Er zijn 4 soorten boekingen (boekstukken):</p>
          <table>
            <tbody>
              <tr><th>Boekstuk</th><th>Wanneer gebruiken</th></tr>
              <tr><td><strong>Bank</strong></td><td>Geld dat binnenkomt of uitgaat via de bank</td></tr>
              <tr><td><strong>Kas</strong></td><td>Contante betalingen</td></tr>
              <tr><td><strong>Inkoop</strong></td><td>Facturen die je ontvangt (kosten)</td></tr>
              <tr><td><strong>Verkoop</strong></td><td>Facturen die je stuurt (omzet)</td></tr>
            </tbody>
          </table>

          <h3>Nieuwe boeking toevoegen</h3>
          <ol>
            <li>Ga naar <strong>Boekingen</strong></li>
            <li>Klik op <strong>+ Nieuwe Boeking</strong></li>
            <li>Kies het type (Bank/Kas/Inkoop/Verkoop)</li>
            <li>Vul in:
              <ul>
                <li><strong>Datum</strong> - Datum van de transactie</li>
                <li><strong>Factuurnummer</strong> - Het nummer op de factuur</li>
                <li><strong>Omschrijving</strong> - Korte beschrijving</li>
                <li><strong>Bedrag incl. BTW</strong> - Het totaalbedrag</li>
                <li><strong>BTW %</strong> - Het BTW percentage (21%, 9%, of 0%)</li>
                <li><strong>Grootboekrekening</strong> - Wat voor soort kosten/opbrengsten</li>
                <li><strong>Relatie</strong> - De klant of leverancier (optioneel)</li>
              </ul>
            </li>
            <li>Klik op <strong>Opslaan</strong></li>
          </ol>

          <h3>Boekingen bekijken</h3>
          <ul>
            <li>Klik op de tabs <strong>Alle / Kas / Bank / Inkoop / Verkoop</strong> om te filteren</li>
            <li>Klik op <strong>Q1 / Q2 / Q3 / Q4</strong> om per kwartaal te filteren</li>
            <li><strong>Dubbelklik</strong> op een regel om de details te zien</li>
          </ul>

          <h3>Document bekijken</h3>
          <p>Als er een PDF of afbeelding is gekoppeld aan een boeking, zie je deze onderaan de detailpagina.</p>
        </div>

        {/* Koppelen */}
        <div className={styles.helpSection}>
          <h2 id="koppelen">Facturen en Betalingen Koppelen</h2>

          <h3>Waarom koppelen?</h3>
          <p>Als je een factuur stuurt (verkoop) of ontvangt (inkoop), is die nog niet betaald. Later komt de betaling binnen via de bank. Door deze te koppelen weet je:</p>
          <ul>
            <li>Welke facturen zijn betaald</li>
            <li>Welke facturen staan nog open</li>
          </ul>

          <h3>Nieuwe betaling toevoegen</h3>
          <ol>
            <li>Ga naar <strong>Boekingen</strong></li>
            <li>Filter op <strong>Bank</strong> of <strong>Kas</strong></li>
            <li>Klik op <strong>+ Betaling</strong></li>
            <li>Kies:
              <ul>
                <li><strong>Inkoop betaling</strong> - Je betaalt een leverancier</li>
                <li><strong>Verkoop betaling</strong> - Een klant betaalt jou</li>
              </ul>
            </li>
            <li>Selecteer de openstaande factuur</li>
            <li>Vul het bedrag en datum in</li>
            <li>Klik op <strong>Opslaan</strong></li>
          </ol>
          <p>De factuur wordt nu als "Betaald" gemarkeerd.</p>
        </div>

        {/* BTW */}
        <div className={styles.helpSection}>
          <h2 id="btw">BTW Overzicht</h2>
          <p>Ga naar <strong>BTW Overzicht</strong> om te zien:</p>
          <ul>
            <li><strong>BTW ontvangen</strong> - BTW die je hebt gefactureerd aan klanten</li>
            <li><strong>BTW betaald</strong> - BTW die je hebt betaald aan leveranciers</li>
            <li><strong>Te betalen</strong> - Het verschil (dit moet je afdragen)</li>
          </ul>
          <p>Klik op <strong>Q1 / Q2 / Q3 / Q4</strong> om per kwartaal te bekijken (handig voor de BTW aangifte).</p>
        </div>

        {/* D&C */}
        <div className={styles.helpSection}>
          <h2 id="dc">Debiteuren & Crediteuren (D&C)</h2>
          <p>Dit overzicht toont:</p>
          <ul>
            <li><strong>Debiteuren</strong> - Klanten die jou nog moeten betalen</li>
            <li><strong>Crediteuren</strong> - Leveranciers die jij nog moet betalen</li>
          </ul>
          <p>Handig om te zien welke facturen nog openstaan.</p>
        </div>

        {/* Relaties */}
        <div className={styles.helpSection}>
          <h2 id="relaties">Relaties</h2>
          <p>Hier beheer je je klanten en leveranciers:</p>
          <ol>
            <li>Ga naar <strong>Relaties</strong></li>
            <li>Klik op <strong>+ Nieuwe Relatie</strong></li>
            <li>Vul in:
              <ul>
                <li>Naam</li>
                <li>Type (Klant, Leverancier, of Beide)</li>
                <li>Adresgegevens (optioneel)</li>
              </ul>
            </li>
            <li>Klik op <strong>Opslaan</strong></li>
          </ol>
          <p>Je kunt relaties selecteren bij het maken van boekingen.</p>
        </div>

        {/* Jaarrekening */}
        <div className={styles.helpSection}>
          <h2 id="jaarrekening">Jaarrekening</h2>
          <p>De complete jaarrekening met:</p>
          <ul>
            <li>Balans</li>
            <li>Winst- en verliesrekening</li>
            <li>Toelichting</li>
          </ul>
          <p>Klik op <strong>Download PDF</strong> om een PDF te maken voor je administratie of accountant.</p>
        </div>

        {/* Instellingen */}
        <div className={styles.helpSection}>
          <h2 id="instellingen">Instellingen</h2>

          <h3>Boekjaar wisselen</h3>
          <p>Klik op <strong>"Boekhouding 2025"</strong> in de linkerzijbalk om van jaar te wisselen.</p>

          <h3>Grootboekrekeningen beheren</h3>
          <p>Bij <strong>Instellingen</strong> kun je grootboekrekeningen toevoegen of bewerken:</p>
          <ul>
            <li>Naam van de grootboekrekening</li>
            <li>Type (Inkomsten/Uitgaven/Neutraal)</li>
            <li>Standaard BTW percentage</li>
          </ul>

          <h3>Beginbalans</h3>
          <p>Klik op <strong>Beginbalans bewerken</strong> om de openingsbalans van het jaar in te voeren.</p>
        </div>

        {/* Tips */}
        <div className={styles.helpSection}>
          <h2 id="tips">Tips</h2>
          <div className={styles.tipBox}>
            <ol>
              <li><strong>Voer boekingen direct in</strong> - Hoe sneller je facturen invoert, hoe beter je overzicht</li>
              <li><strong>Koppel betalingen</strong> - Zo weet je altijd welke facturen nog openstaan</li>
              <li><strong>Check BTW per kwartaal</strong> - Voor de BTW aangifte</li>
              <li><strong>Maak een PDF</strong> - Bij Jaarrekening kun je een PDF downloaden voor je administratie</li>
            </ol>
          </div>
        </div>

        {/* Mobiel */}
        <div className={styles.helpSection}>
          <h2 id="mobiel">Mobiel gebruik</h2>
          <p>De app werkt ook op je telefoon:</p>
          <ul>
            <li><strong>Hamburger menu</strong> - Tik linksboven op de 3 streepjes voor het menu</li>
            <li><strong>Scan bonnetje</strong> - Op het dashboard kun je direct een foto maken van een bon</li>
            <li><strong>Installeren als app (Android)</strong> - In Chrome: Menu → "Toevoegen aan startscherm"</li>
            <li><strong>Installeren als app (iPhone)</strong> - In Safari: Deel-icoon → "Zet op beginscherm"</li>
          </ul>
        </div>

      </div>
    </BoekhoudingLayout>
  );
};

export default Help;
